import type { PlanFeature } from '../../../../data/expandablePlanCardData'

type Props = {
  readonly features?: ReadonlyArray<PlanFeature>
}

/**
 * Features component
 *
 * @returns JSX.Element | null
 */
export function Features({ features }: Props) {
  return features && features.length > 0 ? (
    <div className="border-0 border-b border-solid border-neutral-200 p-4 lg:px-16 md:py-8 lg:py-6">
      <ul className="list-none p-0 m-0 text-center">
        {features.map(feature => (
          <li className="font-bold text-base" key={`feature-${feature.id}`}>
            {feature.feature}
          </li>
        ))}
      </ul>
    </div>
  ) : null
}
